import nutritionalInfo from './partials/nutritional-info.hbs';
import * as productService from '/source/js/services/productService';

let tabIndex = 0;

function initEventHandlers() {
    $('.values-benefits__show-more-link').on('click', function () {
        var $showMoreLink = $(this).children();
        var $tabPane = $(this).closest('.tab-pane');
        var $customTab = $tabPane.parents().find('.custom-tabs__tab-content');
        $tabPane.find('.values-benefits__list-items').slice(4).slideToggle();
        $showMoreLink.text($showMoreLink.text().trim().toLowerCase() === 'show more' ? 'show less' : 'show more');

        $customTab.find('.slick-slide.slick-active').height('auto');
        $customTab.find('.slick-list').height('auto');
        $customTab.slick('setOption', null, null, true);
    });
}
function initSlider() {
    let $customTabsScroll = $('.custom-tabs__nav').not('.ignore-responsive-slick');
    $customTabsScroll.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            var sliderTitleIdName = 'tabs-title-carousel' + key;
            this.id = sliderTitleIdName;
            var sliderTitleId = '#' + sliderTitleIdName;

            var sliderContentIdName = 'tabs-content' + key;
            $('.custom-tabs__tab-content')[key].id = sliderContentIdName;
            // $(this).next()[0].id = sliderContentIdName;
            var sliderContentId = '#' + sliderContentIdName;

            $(sliderTitleId).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: sliderContentId,
                dots: false,
                focusOnSelect: true,
                mobileFirst: true,
                arrows: true,
                speed: 500,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: 'unslick'
                    }
                ]
            });
            $(sliderContentId).slick({
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                asNavFor: sliderTitleId,
                speed: 300,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: 'unslick'
                    }
                ]
            });
        }
    });
}

function showShowMoreLink() {
    $('.tab-pane').each(function () {
        var $items = $(this).find('.values-benefits__list-items');
        var $showMore = $(this).find('.values-benefits__show-more-link');
        if($items.length > 4) {
            $items.slice(4).hide();
            $showMore.show();
        }
    });
}

function filterNutritionalData(selectedProduct) {
    let facetDefinitions = $('.product').data('product-details').FacetDefinitions;
    let name = selectedProduct.Name;
    let dietaryIcons = selectedProduct.Facets.filter(x => x.FacetGroupId === 'cf9a366c4daa46bab6a04b75ba185ee6');
    if(dietaryIcons !== undefined && dietaryIcons !== null && facetDefinitions !== undefined && facetDefinitions !== null) {
        if(dietaryIcons.length > 1) {
            dietaryIcons.forEach(function (item) {
                let facet = facetDefinitions.find(c => c.FacetValueId === item.FacetValueId);
                if(facet !== undefined && facet !== null) {
                    item['Image'] = facet.Image;
                }
            });
        } else {
            let facet = facetDefinitions.find(c => c.FacetValueId === dietaryIcons.FacetValueId);
            if(facet !== undefined && facet !== null) {
                dietaryIcons['Image'] = facet.Image;
            }
        }
    }
    return {
        productName: name,
        dietaryIcons: dietaryIcons
    };
}

function productSelectListener() {
    window.addEventListener('product', (event) => {
        let $nutritionalInfoSection = $('.nutritional-info-section');
        if($nutritionalInfoSection) {
            let fileData = $nutritionalInfoSection.data('nutritional-info');
            let selectedProduct = event.detail.selectedProduct;
            let productData = filterNutritionalData(selectedProduct);
            let nutritionResolver = productService.getProductNutritionalInfo({
                productId: selectedProduct.ID || selectedProduct.Id
            });
            Promise.resolve(nutritionResolver).then(function (result) {
                let nutritionalData = {
                    product: productData,
                    fileInfo: fileData,
                    ingredientInfo: result
                };
                let nutritionalHtml = nutritionalInfo(nutritionalData);
                $nutritionalInfoSection.html(nutritionalHtml);
            });
        }
    });
}

$(function () {
    initSlider();
    initEventHandlers();
    showShowMoreLink();
    // reslick on resizing window from large to medium screens
    $(window).resize(function () {
        if($(window).width() <= 768) {
            const customTabContent = $('.custom-tabs__nav, .custom-tabs__tab-content');
            if(!customTabContent.hasClass('slick-initialized') && !customTabContent.hasClass('ignore-responsive-slick')) {
                customTabContent.slick('reinit');
            }
        }
        stopVideo();
    });
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var tabId = $(e.target).attr('href');
        var $contentCard = $(tabId).find('.content-card');
        $contentCard.each(function (key, item) {
            if($(this).hasClass('bg-pattern')) {
                $(this).removeClass('bg-pattern');
                $(this).find('.content-card__bg-pattern').css('display', 'none');
                $(this).find('.content-card__container').css('height', 'auto');
            }
        });

        stopVideo();
    });

    $('.custom-tabs__tabs-section .slick-prev, .slick-next').on('click', function() {
        if(isTabChanged()) {
            stopVideo();
        }
    });

    productSelectListener();
    $('.custom-tabs__tab-content').on('touchend', function () {
        if(isTabChanged()) {
            stopVideo();
        }
    });
});

function isTabChanged() {
    let activeTab = $('.custom-tabs__tabs-section .slick-list.draggable .slick-track li.slick-current.slick-active');
    let slickIndex = $(activeTab).attr('data-slick-index');
    let slickIndexNumber = parseInt(slickIndex);
    if(slickIndexNumber !== tabIndex) {
        tabIndex = slickIndexNumber;
        return true;
    }
    return false;
}

function stopVideo() {
    $('.tab-pane iframe').each(function () {
        var src = $(this).attr('src');
        var index = src.lastIndexOf('?autoplay=1');
        if(index > 0) {
            src = src.substring(0, index);
        }
        $(this).attr('src', src);
    });
}
